import store from '@/store'
import axios from 'axios'
import { IS_PRODUCTION, HTTP_STATUS, HTTP_HEADER_SKIP_ERROR } from '@/libs/constants'
import { isArray, isPlainObject } from '@/libs/utils'
import { getAuthToken, removeAuthData } from '@/libs/auth-helper'
import { SIGNIN_LINK } from './constants'

let baseUrl = 'http://localhost:8000'

if (process.env.VUE_APP_API_HUB_URL) {
  baseUrl = process.env.VUE_APP_API_HUB_URL
} else if (IS_PRODUCTION) {
  baseUrl = 'https://api-hub.beusable.net'
}

function isApiUrl (url) {
  if (url.charAt(0) === '/') {
    return true
  }
  return url.indexOf(baseUrl) === 0
}

function normalizeRequest (data) {
  if (isPlainObject(data)) {
    for (const key of Object.keys(data)) {
      if (typeof data[key] === 'string') {
        data[key] = data[key].trim()
      } else {
        normalizeRequest(data[key])
      }
    }
  } else if (isArray(data)) {
    for (let i = 0; i < data.length; i++) {
      if (typeof data[i] === 'string') {
        data[i] = data[i].trim()
      } else {
        normalizeRequest(data[i])
      }
    }
  }
}

const httpClientHub = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  validateStatus: function (status) {
    return status >= 200 && status < 500
  }
})

httpClientHub.interceptors.request.use(function (config) {
  if (isApiUrl(config.url)) {
    if (config.data) {
      normalizeRequest(config.data)
    }

    if (config.method === 'get') {
      if (!config.params) {
        config.params = {}
      }
      config.params.t = new Date().getTime()
    }

    const authToken = getAuthToken()

    const userData = store.state.userData

    config.headers = Object.assign(config.headers, {
      // 'BEU-API-Key': `${apiKey}`
      Authorization: `Bearer ${authToken}`
    })
  }
  return config
}, function (error) {
  console.log('hub request error: ', error)
  return Promise.reject(error)
})

httpClientHub.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log('hub error: ', error)

  let needAlert = true
  if (axios.isCancel(error)) {
    return Promise.reject(error)
  }

  if (error.config.headers[HTTP_HEADER_SKIP_ERROR]) {
    needAlert = false
  } else if (error.response && error.response.status) {
    const statusCode = error.response.status

    const authFailedStatusCodes = [
      HTTP_STATUS.unauthrized,
      HTTP_STATUS.unprocessableEntity
    ]
    if (authFailedStatusCodes.includes(statusCode)) {
      needAlert = false
      if (window.__VUE_ROOT__) {
        window.__VUE_ROOT__.$children[0].signOut()
      } else {
        removeAuthData()
      }
      window.location.href = SIGNIN_LINK
    } else if (statusCode === HTTP_STATUS.badRequest) {
      // to-do: what happened?
      return Promise.reject(error)
    }
  }

  // if (needAlert) {
  //   error.isHandled = true
  //   store.commit('setErrorData', { code: 500, error })
  // }
  return Promise.reject(error)
})

export default httpClientHub
